/**
 * Determine if a document is expired or valid based on its expiry date.
 * @param vanhenee - Expiry date in YYYY-MM-DD format
 * @returns "voimassa" if not expired, "vanhentunut" if expired
 */
export function getDokumenttiTila(
  vanhenee: string,
): "voimassa" | "vanhentunut" {
  if (!vanhenee) {
    return "voimassa"; // Default to valid if no date provided
  }

  try {
    const expiryDate = new Date(vanhenee);
    const today = new Date();
    today.setHours(0, 0, 0, 0); // Set to start of day for fair comparison

    return expiryDate >= today ? "voimassa" : "vanhentunut";
  } catch {
    return "voimassa"; // Default to valid if parsing fails
  }
}
